<template>

    <div v-if="isLoading" class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
    </div>


    <div class="row">

        <div class="col-12 col-lg-7 d-flex">
            <div class="card flex-fill">
                <div class="card-header">
                    <h5 class="card-title">Sub Categorias</h5>
                </div>
                <div class="card-body card-buttons">
                    <b-form action="javascript:;">

                        <div class="row">
                            <div class="col-12">
                                <label class="col-form-label">Nombre</label>
                                <b-form-input v-model="nombre" type="text" class="form-control"
                                    :class="{ 'is-invalid': !isNombreValido && nombreTouched }"
                                    placeholder="Nombre de la sub-categoría" required @blur="nombreTouched = true" />
                            </div>

                            <div class="col-12 mt-2">
                                <label class="col-form-label">Categoria</label>
                                <select v-model="category" @focus="loadCategories" @blur="categoryTouched = true"
                                    :disabled="isLoading" class="form-control"
                                    :class="{ 'is-invalid': !isCategoriaValida && categoryTouched }">
                                    <option value="" disabled>Selecciona una categoría</option>
                                    <option v-for="category in categories" :key="category.id" :value="category.id">
                                        {{ category.nombre }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="text-end mt-3">
                            <b-button v-if="!isEditing" @click="submitForm" class="btn-primary m-1"
                                :disabled="!isNombreValido || isLoading">
                                Guardar
                            </b-button>
                            <b-button v-if="isEditing" @click="updateCategory" :disabled="!isNombreValido || isLoading"
                                class="btn-edit m-1">Actualizar</b-button>
                            <b-button v-if="isEditing" @click="deleteCategory"
                                class="btn-danger m-1">Eliminar</b-button>
                            <b-button @click="resetForm" class="btn-clean m-1">Limpiar</b-button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-5 d-flex">
            <div class="card super-admin-dash-card">
                <div class="card-header">
                    <div class="row align-center">
                        <div class="col">
                            <h5 class="card-title">Lista de Sub-Categorías</h5>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive">
                        <table class="table table-stripped table-hover">
                            <thead >
                                <tr>
                                    <th>Sub-categoría</th>
                                    <th>Categoría</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="subcategory in subCategories" :key="subcategory.id"
                                    @click="option(subcategory)">
                                    <td>{{ subcategory.nombre }}</td>
                                    <td>{{ subcategory.categoria.nombre }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';

export default {

    data() {
        return {
            nombreTouched: false,
            categoryTouched: false,
            subCategoryId: '',
            subCategories: [],
            categories: [],
            category: '',
            nombre: '',
            isLoading: false,
            error: null,
            isEditing: false,
        };
    },
    mounted() {
        this.loadCategories();
        this.loadSubCategories();
    },

    methods: {
        async loadSubCategories() {
            try {
                const response = await api.get('/sub_categoria');
                this.subCategories = response.data;
            } catch (err) {
                this.error = 'Error al cargar sub-categorías';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },
        async loadCategories() {
            try {
                const response = await api.get('/categoria');
                this.categories = response.data;
            } catch (err) {
                this.error = 'Error al cargar sub-categorías';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },
        async submitForm() {

            const result = await this.$swal.fire({
                title: '¿Guardar Sub-Categoría?',
                text: 'Se guardará una nueva Sub-Categoría.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, guardar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;
            this.isLoading = true;

            let data = {
                nombre: this.nombre,
                categoriaId: this.category
            }

            try {
                const response = await api.post("/sub_categoria", data);
                this.isLoading = false;
                this.$toast.success('Sub-Categoría agregada con éxito');
                this.resetForm();
                this.loadSubCategories();
            } catch (error) {
                this.isLoading = false;
                this.$toast.error('Error al agregada la Sub-Categoría');
            }
        },
        option(subCategory) {
            this.isEditing = true;

            this.subCategoryId = subCategory.id;
            this.nombre = subCategory.nombre;
            this.category = subCategory.categoriaId;

        },
        async updateCategory() {

            const result = await this.$swal.fire({
                title: '¿Actualizar Sub-Categoría?',
                text: 'Se modificará la Sub-Categoría seleccionada.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, actualizar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;

            this.isLoading = true;

            let data = {
                nombre: this.nombre,
                categoriaId: this.category
            }

            try {
                const response = await api.put(`/sub_categoria/${this.subCategoryId}`, data);
                this.isLoading = false;
                this.$toast.success('Sub-Categoría actualizada con éxito');
                this.resetForm();
                this.loadSubCategories();
            } catch (error) {
                this.isLoading = false;
                this.$toast.error('Error al actualizar Sub-Categoría');
                console.error("Error:", error);
            }
        },
        async deleteCategory() {

            const result = await this.$swal.fire({
                title: '¿Eliminar Sub-Categoría?',
                text: 'Esta acción no se puede deshacer.',
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;
            this.isLoading = true;

            try {
                const response = await api.delete(`/sub_categoria/${this.subCategoryId}`);
                this.isLoading = false;
                this.$toast.success('Sub-Categoría eliminada con éxito');
                this.resetForm();
                this.loadSubCategories();
            } catch (error) {
                this.isLoading = false;
                this.$toast.error('Error al eliminar Sub-Categoría');
                console.error("Error:", error);
            }
        },

        resetForm() {
            this.nombreTouched = false;
            this.categoryTouched = false;
            this.subCategoryId = '';
            this.nombre = '';
            this.category = '';
            this.isEditing = false;
        },
    },
    computed: {
        isNombreValido() {
            return this.nombre.trim().length > 0;
        },
        isCategoriaValida() {
            return this.category !== '';
        }
    }

};
</script>

<style>
td {
    cursor: pointer;
    transition: background-color 0.2s;
}


.is-invalid {
    border-color: #dc3545;
}

thead tr th{ 
    background-color: #7539FF !important;
    color: white !important;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(2px);
}
</style>
